import { IRoutes } from 'common/interfaces/routes';
import messages from 'modules/dictionaries/messages/messages';
import notificationMessages from 'modules/dictionaries/messages/notifications';
import commonMessages from 'common/messages/messages';
import { EndReasonActionTypes } from '../interfaces/interfaces';
import {
  PermissionLevels,
  PoliciesPermissionSetItems as Permission,
} from 'common/constants/permissions';
import { Routes } from 'constants/route.constants';
import IntlService from 'services/intl/IntlService';

export enum DictionariesTypes {
  CAME_FROM_INDICATION = 'CAME_FROM_INDICATION',
  ALERT_SOUND_UPLOAD = 'ALERT_SOUND_UPLOAD',
  NOTE_CODE = 'NOTE_CODE',
  FALLTHROUGH_REASON = 'FALLTHROUGH_REASON',
  DEPARTMENTS = 'DEPARTMENTS',
  EVENT_TAGS = 'EVENT_TAGS',
  RESOURCE_TAG = 'RESOURCE_TAG',
  ADDITIONAL_GUEST_FIELDS = 'ADDITIONAL_GUEST_FIELDS',
  END_REASON = 'END_REASON',
}

export enum TagType {
  FRONTDESK_PROFILE = 'FRONTDESK_PROFILE',
  INVENTORY_CATEGORY = 'INVENTORY_CATEGORY',
}

export const endReasonActionTypesLabels = {
  [EndReasonActionTypes.ZIP_CODE]: 'zipCodeOption',
  [EndReasonActionTypes.MD_LICENSE]: 'mdLicenseOption',
  [EndReasonActionTypes.NOTE_CODE]: 'noteCodeOption',
};

export const getEndReasonActionTypeOptions = () => [
  {
    key: EndReasonActionTypes.ZIP_CODE,
    label: IntlService.formatMessage(
      messages[endReasonActionTypesLabels[EndReasonActionTypes.ZIP_CODE]],
    ),
    value: EndReasonActionTypes.ZIP_CODE,
  },
  {
    key: EndReasonActionTypes.MD_LICENSE,
    label: IntlService.formatMessage(
      messages[endReasonActionTypesLabels[EndReasonActionTypes.MD_LICENSE]],
    ),
    value: EndReasonActionTypes.MD_LICENSE,
  },
  {
    key: EndReasonActionTypes.NOTE_CODE,
    label: IntlService.formatMessage(
      messages[endReasonActionTypesLabels[EndReasonActionTypes.NOTE_CODE]],
    ),
    value: EndReasonActionTypes.NOTE_CODE,
  },
];

export const routes: IRoutes[] = [
  {
    type: 'bookmark',
    message: commonMessages.frontDesk,
    levels: [PermissionLevels.CORPORATE, PermissionLevels.CLIENT],
    permissions: [
      Permission.CAME_FROM_INDICATION_VIEW,
      Permission.ADDITIONAL_GUEST_FIELD_VIEW,
      Permission.ALERT_SOUND_VIEW,
      Permission.NOTE_CODE_VIEW,
    ],
  },
  {
    type: 'link',
    path: Routes.DICTIONARY_CAME_FROM_INDICATION,
    message: messages.cameFromIndication,
    levels: [PermissionLevels.CORPORATE, PermissionLevels.CLIENT],
    permissions: [Permission.CAME_FROM_INDICATION_VIEW],
  },
  {
    type: 'link',
    path: Routes.DICTIONARY_ADDITIONAL_GUEST_FIELDS,
    message: messages.additionalGuestFields,
    levels: [PermissionLevels.CORPORATE, PermissionLevels.CLIENT],
    permissions: [Permission.ADDITIONAL_GUEST_FIELD_VIEW],
  },
  {
    type: 'link',
    path: Routes.DICTIONARY_ALERT_SOUND_UPLOAD,
    message: messages.alertSoundUpload,
    levels: [PermissionLevels.CORPORATE, PermissionLevels.CLIENT],
    permissions: [Permission.ALERT_SOUND_VIEW],
  },
  {
    type: 'link',
    path: Routes.DICTIONARY_NOTE_CODE,
    message: messages.noteCode,
    levels: [PermissionLevels.CORPORATE, PermissionLevels.CLIENT],
    permissions: [Permission.NOTE_CODE_VIEW],
  },
  {
    type: 'bookmark',
    message: commonMessages.crm,
    levels: [PermissionLevels.CORPORATE, PermissionLevels.CLIENT],
    permissions: [Permission.FALLTHROUGH_REASON_VIEW],
  },
  {
    type: 'link',
    path: Routes.DICTIONARY_FALLTHROUGH_REASON,
    message: messages.fallthroughReason,
    levels: [PermissionLevels.CORPORATE, PermissionLevels.CLIENT],
    permissions: [Permission.FALLTHROUGH_REASON_VIEW],
  },
  {
    type: 'bookmark',
    message: messages.clubSetup,
    levels: [PermissionLevels.CORPORATE, PermissionLevels.CLIENT],
    permissions: [
      Permission.DEPARTMENT_VIEW,
      Permission.CLIENT_GROUP_VIEW,
      Permission.INSURANCE_COMPANY_VIEW,
      Permission.ACCESS_HOUR_VIEW,
    ],
  },
  {
    type: 'link',
    path: Routes.DICTIONARY_DEPARTMENTS,
    message: messages.departments,
    levels: [PermissionLevels.CORPORATE, PermissionLevels.CLIENT],
    permissions: [Permission.DEPARTMENT_VIEW],
  },
  {
    type: 'link',
    path: Routes.DICTIONARY_CLUB_GROUPS,
    message: messages.clubGroups,
    levels: [PermissionLevels.CORPORATE, PermissionLevels.CLIENT],
    permissions: [Permission.CLIENT_GROUP_VIEW],
  },
  {
    type: 'link',
    path: Routes.DICTIONARY_INSURANCE_COMPANIES,
    message: messages.insuranceCompanies,
    levels: [PermissionLevels.CORPORATE, PermissionLevels.CLIENT],
    permissions: [Permission.INSURANCE_COMPANY_VIEW],
  },
  {
    type: 'link',
    path: Routes.DICTIONARY_ACCESS_HOURS,
    message: messages.accessHours,
    levels: [PermissionLevels.CORPORATE, PermissionLevels.CLIENT],
    permissions: [Permission.ACCESS_HOUR_VIEW],
  },
  {
    type: 'bookmark',
    message: commonMessages.booking,
    levels: [PermissionLevels.CORPORATE, PermissionLevels.CLIENT],
    permissions: [Permission.EVENT_TAG_VIEW, Permission.RESOURCE_TAG_VIEW],
  },
  {
    type: 'link',
    path: Routes.DICTIONARY_EVENT_TAGS,
    message: messages.eventsTags,
    levels: [PermissionLevels.CORPORATE, PermissionLevels.CLIENT],
    permissions: [Permission.EVENT_TAG_VIEW],
  },
  {
    type: 'link',
    path: Routes.DICTIONARY_RESOURCE_TAGS,
    message: messages.resourcesTags,
    levels: [PermissionLevels.CORPORATE, PermissionLevels.CLIENT],
    permissions: [Permission.RESOURCE_TAG_VIEW],
  },
  {
    type: 'bookmark',
    message: commonMessages.automation,
    levels: [PermissionLevels.CORPORATE, PermissionLevels.CLIENT],
    permissions: [Permission.NOTIFICATION_VIEW],
  },
  {
    type: 'link',
    path: Routes.DICTIONARY_NOTIFICATIONS,
    message: notificationMessages.notificationsTitle,
    levels: [PermissionLevels.CORPORATE, PermissionLevels.CLIENT],
    permissions: [Permission.NOTIFICATION_VIEW],
  },
  {
    type: 'bookmark',
    message: commonMessages.generalLabel,
    levels: [PermissionLevels.CORPORATE, PermissionLevels.CLIENT, PermissionLevels.PEAK],
    permissions: [
      Permission.PEAK_HELP_INFORMATION_VIEW,
      Permission.HELP_INFORMATION_VIEW,
      Permission.END_REASON_VIEW,
    ],
  },
  {
    type: 'link',
    path: Routes.DICTIONARY_HELP_INFORMATION,
    message: messages.helpInformation,
    levels: [PermissionLevels.CORPORATE, PermissionLevels.CLIENT, PermissionLevels.PEAK],
    permissions: [Permission.PEAK_HELP_INFORMATION_VIEW, Permission.HELP_INFORMATION_VIEW],
  },
  {
    type: 'link',
    path: Routes.DICTIONARY_END_REASON,
    message: messages.endReason,
    levels: [PermissionLevels.CORPORATE, PermissionLevels.CLIENT],
    permissions: [Permission.END_REASON_VIEW],
  },
  {
    type: 'link',
    path: Routes.DICTIONARY_ADJUSTMENT_CATEGORY,
    message: messages.adjustmentCategory,
    levels: [PermissionLevels.PEAK],
    permissions: [Permission.PEAK_ADJUSTMENT_CATEGORY_VIEW],
  },
];
